import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const BuzzerMuteGlyph = /*#__PURE__*/createElement("g", {
  id: "buzzer_mute"
}, /*#__PURE__*/createElement("path", {
  d: "M48.55 19.67c-.63-.35-1.42-.29-2.09.14L29.47 30.75c-.21.14-.41.31-.59.51H16.96c-1.23 0-2.24 1-2.24 2.24v17.01c0 1.23 1 2.23 2.24 2.23h11.93c.18.2.37.37.59.51l16.98 10.94c.38.24.79.37 1.19.37.31 0 .62-.08.9-.23.64-.35 1.02-1.03 1.02-1.83v-41c0-.8-.38-1.48-1.02-1.83zM17.3 33.84h10.69v16.32H17.3V33.84zm29.27 26.85l-15.44-9.95a.707.707 0 01-.13-.21V33.5c.01-.07.08-.2.11-.23l15.47-9.97v37.39zm15.11-18.58l7.38-7.38c.5-.5.5-1.3 0-1.8s-1.3-.5-1.8 0l-7.38 7.38-7.38-7.38c-.5-.5-1.3-.5-1.8 0s-.5 1.3 0 1.8l7.38 7.38-7.38 7.38c-.5.5-.5 1.3 0 1.8.25.25.57.37.9.37s.65-.12.9-.37l7.38-7.38 7.38 7.38c.25.25.57.37.9.37s.65-.12.9-.37c.5-.5.5-1.3 0-1.8l-7.38-7.38z"
}));
const BuzzerMute = createSvg({
  name: 'buzzer_mute',
  path: BuzzerMuteGlyph
});

export default BuzzerMute;
export { BuzzerMuteGlyph };
